<template>
  <div :class="$style.article">
    <aw-aggregated-pages-cards
      :page-type="content.articleType"
      :params="{
        limit: content?.articleCount || 12,
        highlighted: null
      }"
      hide-load-more-button
      :analytics-banner-interaction="analyticsBannerInteraction"
      :analytics-measurable="analyticsMeasurable"
    />
    <div :class="$style.articleButton">
      <lv-button
        styling="secondary-dark"
        shrink
        :href="navigateButton.href"
        v-on="genBannerInteractionClickEventHandlers({
          title: navigateButton.text
        })"
      >
        {{ navigateButton.text }}
      </lv-button>
    </div>
  </div>
</template>

<script>
  import analyticsBannerInteractionMixin from '~~/common/mixins/analyticsBannerInteractionMixin.js';
  import AwAggregatedPagesCards from '~~/shop/components/Common/AggregatedPages/AwAggregatedPageCards.vue';
  import { LvButton } from '~~/common/components/loginet-vue-shop/index.mjs';

  export default {
    name: 'AwArticleList',
    components: {
      AwAggregatedPagesCards,
      LvButton,
    },
    mixins: [analyticsBannerInteractionMixin],
    props: {
      content: {
        type: Object,
        required: true,
      },
    },
    computed: {
      navigateButton () {
        const buttonOptions = {
          press_release: {
            href: this.localePath('/press'),
            text: this.$awt('aw.common.article_list.button.press'),
          },
          news: {
            href: this.localePath('/news'),
            text: this.$awt('aw.common.article_list.button.news'),
          },
          csr: {
            href: this.localePath('/csr'),
            text: this.$awt('aw.common.article_list.button.csr'),
          },
          inspiration: {
            href: this.localePath('/inspirations'),
            text: this.$awt('aw.common.article_list.button.inspiration'),
          },
          default: {
            href: this.localePath('/'),
            text: this.$awt('aw.common.article_list.button.default'),
          },
        };
        return buttonOptions?.[this.content?.articleType] || buttonOptions.default;
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.article {
  &Button {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
    @include tablet(min) {
      margin-top: 40px;
    }
  }
}
</style>
